import { Input, Component, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

import type { PreviewRoute } from '../../utils/get-preview-paths';

@Component({
  selector: 'email-preview-nav',
  template: `<div class="mode">
      <a
        [routerLink]="active?.interpolatedUrl"
        [routerLinkActive]="'active'"
        (click)="$event.stopPropagation()"
        >Preview</a
      >
      |
      <a
        [routerLink]="active?.mailgunUrl"
        [routerLinkActive]="'active'"
        (click)="$event.stopPropagation()"
        >Mailgun</a
      >
    </div>
    <ul data-theme="light">
      @for (route of routes; track trackByRoute($index, route)) {
        <li [routerLink]="route.interpolatedUrl" [class.active]="active === route">
          {{ route.name }}
        </li>
      }
    </ul>`,
  styleUrls: ['./email-preview-nav.component.less'],
  imports: [RouterLink, RouterLinkActive],
})
export class EmailPreviewNavComponent {
  public router = inject(Router);

  @Input() public routes: PreviewRoute[];
  @Input() public active?: PreviewRoute;

  public trackByRoute(index: number, route: PreviewRoute): string {
    return route.mailgunUrl;
  }
}
